import { gql } from '@apollo/client'

export const getBrandRedirectQuery = gql`
  query GetBrandRedirectSlug($slug: String!) {
    findBrandRedirect(slug: $slug) {
      slug
    }
  }
`
